import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { EsnRole } from '../../../shared/types/atoms';

type Tone = 'neutral' | 'faded' | 'warning';

const TONES: Record<EsnRole, Tone> = {
  admin: 'warning',
  editor: 'neutral',
  viewer: 'faded',
};

/**
 * Shows which of the three user roles a member holds, in the same tag material as the
 * status badge. The label is projected; `role` picks the colour.
 */
@Component({
  selector: 'esn-role-badge',
  templateUrl: './role-badge.component.html',
  styleUrl: './role-badge.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleBadgeComponent {
  readonly role = input.required<EsnRole>();

  protected readonly classes = computed(() => `esn-tag esn-tag--${TONES[this.role()]}`);
}
